import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const chatLockUnlockStatus = createAsyncThunk('chatLockUnlockStatus', async (data) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `chat_lock_unlock`,
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const chatLockUnlockStatusSlice = createSlice({
    name: 'chatLockUnlockStatus',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(chatLockUnlockStatus.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(chatLockUnlockStatus.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default chatLockUnlockStatusSlice.reducer; 